import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Firebase } from '../../../Core'

import * as selectors from '../quizzes.selectors'
import * as actions from '../quizzes.actions'
import * as utils from '../quizzes.utils'

import * as miningActions from '../../Mining/mining.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

const FILTERS = ['disputed', 'own', 'resolved', null]

const ResolvedDispute = ({ color, icon }) => [
  <div key="icons" className={`icons ${color}`}>
    <div className={`icons--item ${color}`}>
      <span className={`icon-${icon}`}> </span>
    </div>
  </div>,
  <div key="state" className={`icons--item ${color}`}>
    <FormattedMessage id="questions.done" />
  </div>,
]

const PendingDispute = ({ votes }) => [
  <div key="icons" className="icons">
    <div className="icons--item">
      <span className="icon-like darkgreen"> </span>
      <span>{Math.trunc(votes.valid)}%</span>
    </div>
    <div className="icons--item">
      <span className="icon-dislike red"> </span>
      <span>{Math.trunc(votes.invalid)}%</span>
    </div>
  </div>,
  <div key="state" className="state">
    <FormattedMessage id="questions.incourse" />
  </div>,
]

/**
 *  Pop up showed when you have finished the game
 */

class DisputeQuestionList extends React.Component {
  constructor() {
    super()
    this.state = {
      filterActive: 'disputed',
    }
  }

  searchQuestion(e) {
    const { searchQuestion } = this.props
    const elements = this.form

    e.preventDefault()
    e.stopPropagation()

    searchQuestion(elements['search'].value)
  }

  changeFilter(filter) {
    const { changeFilter, addHowlSound } = this.props

    changeFilter(filter)
    this.setState({ filterActive: filter })
    addHowlSound('button_click')
  }

  componentWillUnmount() {
    const { changeFilter, searchQuestion } = this.props

    changeFilter('disputed')
    searchQuestion(null)
  }

  getVotesAvg(votes) {
    const total = votes['positive'] + votes['negative']
    const valid = total ? (votes['positive'] / total) * 100 : 0
    const invalid = total ? (votes['negative'] / total) * 100 : 0

    return { valid, invalid }
  }

  disputeQuestion(question) {
    const { changeMiningScreen, setVoteQuestion } = this.props

    question.state == 'toDispute'
      ? setVoteQuestion(question)
      : setVoteQuestion({ ...question, onlyView: true })
    changeMiningScreen('vote_question')
  }

  renderFilter(filter) {
    const { filterActive } = this.state
    const filterName = filter ? `questions.${filter}` : 'questions.all'

    return (
      <li
        key={filterName}
        onClick={() => this.changeFilter(filter)}
        className={`tabs--item ${filter == filterActive ? 'active' : ''}`}
      >
        <FormattedMessage id={filterName} />
      </li>
    )
  }

  renderSearch() {
    const { intl } = this.props
    const search = intl.formatMessage({ id: 'questions.search' })

    return (
      <form ref={(form) => (this.form = form)} className="search--game">
        <input
          className="input--search"
          onClick={() => {
            this.changeFilter('search')
          }}
          onKeyUp={(e) => this.searchQuestion(e)}
          type="text"
          id="search"
          name="search"
          placeholder={search}
        />
      </form>
    )
  }
  renderOption(question) {
    const { debatePrizeCoins } = this.props
    const debateVotes = utils.getVotes(question.dispute.debate)
    const votes = this.getVotesAvg(debateVotes)

    const render = {
      lost: <ResolvedDispute color="red" icon="close" />,
      won: <ResolvedDispute color="darkgreen" icon="badge" />,
      not: <ResolvedDispute color="darkgreen" icon="close" />,
      disputed: <PendingDispute votes={votes} />,
      toDispute: (
        <div className="btn--shape shape--violet">
          <div className="btn--shape__canvas">
            <span>
              <FormattedMessage id="mining.actionButton" values={{ gcoins: debatePrizeCoins }} />
              <span className="icon-coin" />
            </span>
            <span className="color--blue">
              : {debatePrizeCoins}
              <span className="icon-antimateria" />
            </span>
          </div>
        </div>
      ),
    }

    return render[question.state]
  }

  renderQuestion(question) {
    const { userData } = this.props

    return (
      <div
        key={question.id}
        onClick={() => this.disputeQuestion(question)}
        className={`mina--historial__item ${userData.id == question.createdBy ? 'mine' : ''}`}
      >
        <div className="text">
          {userData.id == question.createdBy ? (
            <span className="icon-self-question orange"></span>
          ) : null}
          {question.question}
        </div>
        <div className="mina--historial__info">{this.renderOption(question)}</div>
      </div>
    )
  }

  render() {
    const { questionsList, error } = this.props

    if (error) {
      return (
        <div className="mina--layer">
          <FormattedMessage id="questions.loading" />
        </div>
      )
    }

    if (!questionsList) {
      return (
        <div className="mina--layer">
          <FormattedMessage id="questions.loading" />
        </div>
      )
    }

    return (
      <div className="mina--historial growIn-animation">
        {this.renderSearch()}
        <ul className="tabs">{FILTERS.map((filter) => this.renderFilter(filter))}</ul>
        <div className="mina--historial__container">
          {questionsList.map((question) => this.renderQuestion(question))}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    changeMiningScreen: bindActionCreators(miningActions.changeMiningScreen, dispatch),
    changeFilter: bindActionCreators(actions.changeFilter, dispatch),
    searchQuestion: bindActionCreators(actions.searchQuestion, dispatch),
    setVoteQuestion: bindActionCreators(actions.setVoteQuestion, dispatch),
  }
}

const mapStateToProps = (state) => {
  return {
    error: selectors.isSavedError(state),
    debatePrizeCoins: selectors.getDebatePrizeCoins(state),
    userData: Firebase.selectors.getUserData(state),
    questionsList: selectors.getFilteredDisputesList(state),
  }
}

DisputeQuestionList.propTypes = {
  error: PropTypes.boolean,
  questionsList: PropTypes.array,
  userData: PropTypes.object,
  debatePrizeCoins: PropTypes.number,
  changeFilter: PropTypes.func,
  changeMiningScreen: PropTypes.func,
  addHowlSound: PropTypes.func,
  setVoteQuestion: PropTypes.func,
  searchQuestion: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DisputeQuestionList))
